(ns livefeed.properties)

(def ^:private properties (atom nil))

(def ^:private env->properties {:dev-test   {:tunnus-profile-href "https://tunnus-test.yle.fi#omat-tiedot"
                                             :websocket-api {:host "chat-websocket.api-test.yle.fi"
                                                             :path "/v1/livefeed"
                                                             :protocol :https}
                                             :tunnus
                                             {:language "fi"
                                              :trackingAppName "yle-comments-livefeed-widget-test"
                                              :initiatingApp "yle-comments-livefeed-widget-test"
                                              :environment "test"}
                                             :login-api-url "https://login.api-test.yle.fi"
                                             :backend-api-url "https://chat-backend.api-test.yle.fi"
                                             :chat-public-url "https://chat-public.test.yle.fi"
                                             :images-api-url "https://img-test.img-cdn.yle.fi"
                                             :base-url ""
                                             :appId "livefeed_chat_widget_test"
                                             :appKey "42c5f996d281d2ea41b56e9725882a39"}
                                :dev-local  {:tunnus-profile-href "https://tunnus-test.yle.fi#omat-tiedot"
                                             :websocket-api {:host "chat-websocket-api.local.yle.fi"
                                                             :path "/v1/livefeed"
                                                             :protocol :https}
                                             :tunnus
                                             {:language "fi"
                                              :trackingAppName "yle-comments-livefeed-widget-test"
                                              :initiatingApp "yle-comments-livefeed-widget-test"
                                              :environment "test"}
                                             :login-api-url "https://login.api-test.yle.fi"
                                             :backend-api-url "https://chat-backend.local.yle.fi"
                                             :chat-public-url "https://chat-public.local.yle.fi"
                                             :images-api-url "https://img-test.img-cdn.yle.fi"
                                             :base-url ""
                                             :appId "livefeed_chat_widget_test"
                                             :appKey "42c5f996d281d2ea41b56e9725882a39"}
                                :test       {:tunnus-profile-href "https://tunnus-test.yle.fi#omat-tiedot"
                                             :websocket-api {:host "chat-websocket.api-test.yle.fi"
                                                             :path "/v1/livefeed"
                                                             :protocol :https}
                                             :tunnus
                                             {:language "fi"
                                              :trackingAppName "yle-comments-livefeed-widget-test"
                                              :initiatingApp "yle-comments-livefeed-widget-test"
                                              :environment "test"}
                                             :login-api-url "https://login.api-test.yle.fi"
                                             :backend-api-url "https://chat-backend.api-test.yle.fi"
                                             :chat-public-url "https://chat-public.test.yle.fi"
                                             :images-api-url "https://img-test.img-cdn.yle.fi"
                                             :base-url "https://yle-comments-livefeed-widget.apps-test.yle.fi"
                                             :appId "livefeed_chat_widget_test"
                                             :appKey "42c5f996d281d2ea41b56e9725882a39"}
                                :production {:tunnus-profile-href "https://tunnus.yle.fi#omat-tiedot"
                                             :websocket-api {:host "chat-websocket.api.yle.fi"
                                                             :path "/v1/livefeed"
                                                             :protocol :https}
                                             :tunnus
                                             {:language "fi"
                                              :trackingAppName "yle-comments-livefeed-widget-production"
                                              :initiatingApp "yle-comments-livefeed-widget-production"
                                              :environment "production"}
                                             :login-api-url "https://login.api.yle.fi"
                                             :backend-api-url "https://chat-backend.api.yle.fi"
                                             :chat-public-url "https://chat-public.yle.fi"
                                             :images-api-url "https://img.img-cdn.yle.fi"
                                             :base-url "https://yle-comments-livefeed-widget.apps.yle.fi"
                                             :appId "livefeed_chat_widget_prod"
                                             :appKey "96647595e47c00b5d3ff13ad2bfff831"}})

(defn use-env! [env]
  (->> (keyword env)
       (env->properties)
       (reset! properties)))

(defn add-properties! [props]
  (swap! properties merge props))

(defn get-property [& keys]
  (get-in @properties keys))
